module.exports = __webpack_public_path__ + "static/media/gameStartSound.93001ff1.mp3";